import { Spacer, TextSubtitle } from '@pypestream/design-system';
import {
  TranslationComponent,
  TranslationKeys,
} from '@pypestream/translations';
import { type CSSProperties, type FC } from 'react';
import { PuffLoader } from 'react-spinners';

export const Loader: FC<{
  relative?: boolean;
  i18nKey?: string;
  progress?: string | number;
}> = ({ relative, i18nKey = 'pro-studio/common:loading', progress }) => (
  <div
    className={relative ? '' : 'u-full-width u-full-height u-overflow-hidden'}
    style={{
      minHeight: relative ? '100%' : 'calc(100vh - 60px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    }}
  >
    <PuffLoader color="#5956E3" size={60} speedMultiplier={2} />
    <Spacer size="small" />
    <TextSubtitle>
      <TranslationComponent i18nKey={i18nKey as TranslationKeys}>
        Loading
      </TranslationComponent>
      {progress ? `: ${progress}%` : '...'}
    </TextSubtitle>
  </div>
);

// `fixed`, not `absolute`: this div is slotted into <ps-page>, whose only
// ancestors up to <body> are unpositioned (`ps-page` is `display: contents`,
// `.c-page` is a plain grid), so `position: absolute` resolved against the
// INITIAL containing block — i.e. the top of the DOCUMENT, not the viewport.
// Arriving on a route with a non-zero scroll therefore parked the spinner
// above the fold and the user saw a blank page (PSTUDIO-4217).
//
// `zIndex` sits below `ps-nav`'s 101 on purpose: the overlay covers the page
// body while a route loads, but must not paint over the (still functional)
// primary nav, which is what the old 1000 did.
export const centeredContainerStyles: CSSProperties = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 100,
};
